import { Typography } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';

/** Top-right note that Control Next shows static slide images for PowerPoint decks. */
export function FlowControlNextStaticPreviewDisclaimer() {
  const t = useTranslations();
  return (
    <Typography
      component="span"
      sx={{
        position: 'absolute',
        top: 8,
        right: 10,
        zIndex: 1,
        maxWidth: '55%',
        color: '#fff',
        textShadow: '0 0 1px rgba(0,0,0,0.9), 0 1px 3px rgba(0,0,0,0.75)',
        fontWeight: 600,
        fontSize: '0.7rem',
        lineHeight: 1.25,
        textAlign: 'right',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      {t('flows.detail.control.nowNext.staticPresentationPreview', {
        defaultValue: 'Static preview — no videos and animations',
      })}
    </Typography>
  );
}
